import { Component, OnInit, ElementRef, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PickupServiceService } from 'src/app/services/pickup/pickup-service.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-pickup-details',
  templateUrl: './pickup-details.component.html',
  styleUrls: ['./pickup-details.component.scss'],
})
export class PickupDetailsComponent implements OnInit {
  @Input() storeId: number;
  @Input() locationId: number; 
  deliveryDate: string;
  datePickerObj: any;
  monthsList: string[];
  timeSlot: { start: string, end: string };
  flightId: string;
  weeksList: string[];
  timeSlotCaption: string;
  manualTime: string;
  timePickerObj: any;
  timeSlotData: any[];
  errorMessage: {
    flightId: boolean;
    date: boolean;
    slot: boolean;
  };
  showSlots: boolean;
  // tslint:disable-next-line: max-line-length
  constructor(private modalController: ModalController, private el: ElementRef, private pickupService: PickupServiceService, private datePipe: DatePipe) {
    this.timeSlot = { start: '', end: '' };

    this.errorMessage = {
      flightId: false,
      date: false,
      slot: false,
    };
  }

  onTimeSlotSelect(item) {
    this.timeSlot = item;
    this.timeSlotCaption = this.datePipe.transform(new Date(this.timeSlot.start), 'shortTime') + ' - ' + this.datePipe.transform(new Date(this.timeSlot.end), 'shortTime');
  }

  ngOnInit() {

    this.initializeUIState();
    // tslint:disable-next-line: max-line-length
    this.updateTimeSlots();
  }

  validateCart() {
    this.errorMessage = {
      flightId: false,
      date: false,
      slot: false
    };
    if (this.deliveryDate) {
      if (!this.flightId && !this.timeSlot.start && !this.manualTime) {
        this.errorMessage.flightId = true;
        return;
      }
      if(!this.manualTime){
        this.errorMessage.slot = true;
        return;
      }
      if(!this.flightId){
        this.errorMessage.flightId = true;
        return;
      }
      if (this.showSlots){
          if (!this.timeSlot.start && this.manualTime) {
            this.timeSlot.start = this.datePipe.transform(new Date(this.deliveryDate), 'yyyy-MM-dd') + ' ' + this.datePipe.transform(new Date(this.manualTime), 'shortTime');
            let endTime = new Date(this.timeSlot.start);
            endTime.setMinutes(endTime.getMinutes() + 30);
            this.timeSlot.end = this.datePipe.transform(new Date(endTime), 'yyyy-MM-dd') + ' ' + this.datePipe.transform(new Date(endTime), 'shortTime');
          }
      }
    } else {
      this.errorMessage.date = true;
      return;
    }
    this.pickupService.validateCart(this.storeId, this.locationId, this.timeSlot.start, this.datePipe.transform(new Date(this.deliveryDate), 'yyyy-MM-dd'), this.flightId)
      .toPromise()
      .then((response) => {
        if (response[0].status_code || response[0].ValidationStatus === 1) {
          let selectedTimeSlot = this.timeSlot.start ? this.datePipe.transform(new Date(this.timeSlot.start), 'shortTime') + ' - ' + this.datePipe.transform(new Date(this.timeSlot.end), 'shortTime') : '';
          if(localStorage.getItem("pid") == "asp"){
              localStorage.setItem("flight_id", this.flightId);
              localStorage.setItem("flight_date", this.deliveryDate);
              localStorage.setItem("pickup_time", this.manualTime);
          }
          this.modalController.dismiss(
            {
              validationResults: response[0],
              flightId: this.flightId,
              timeSlot: selectedTimeSlot,
              date: this.deliveryDate
            }
          );
        } else {
          // display error
        }
      });
  }
  updateTimeSlots(date?: string) {
    // enable
    this.timeSlotData = [];
    this.timeSlotCaption = '';
    const expectedDate = date ? new Date(date) : new Date();
    // tslint:disable-next-line: max-line-length
    this.pickupService.getTimeSlots(this.datePipe.transform(expectedDate, 'yyyy-MM-dd'), this.storeId, this.locationId).toPromise().then((response) => {
      let timeSlotResponse = response['timeslots'];
      timeSlotResponse.forEach((element, index) => {
        timeSlotResponse[index].start = element.start.replace(/-/g, '/');
        timeSlotResponse[index].end = element.end.replace(/-/g, '/');
      });
      this.timeSlotData = timeSlotResponse;
    });
  }

  initializeUIState() {
    this.showSlots = true;
    const date = new Date();
    if(localStorage.getItem("pid") == "asp"){
      this.showSlots = false;
      date.setDate(date.getDate() + 3); //Allowing orders after 72 hrs only
    }
    this.deliveryDate = this.datePipe.transform(date, 'dd MMM yyyy');
    this.timeSlotData = [];
    // Initializing Date Picker Properties
    this.monthsList = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ];
    this.weeksList = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

    /*     const disabledDates: Date[] = [
      new Date(1545911005644),
      new Date(),
      new Date(2018, 12, 12), // Months are 0-based, this is August, 10th.
      new Date('Wednesday, December 26, 2018'), // Works with any valid Date formats like long format
      new Date('12-14-2018') // Short format
    ]; */
    // reference URL https://www.logisticinfotech.com/blog/ionic4-datepicker-component/
    this.datePickerObj = {
      // inputDate: new Date('12'), // If you want to set month in date-picker
      // inputDate: new Date('2018'), // If you want to set year in date-picker
      // inputDate: new Date('2018-12'), // If you want to set year & month in date-picker
      // inputDate: new Date('2018-12-01'), // If you want to set date in date-picker

      fromDate: this.deliveryDate, // need this in order to have toDate
      // toDate: new Date('2019-12-25'),
      // showTodayButton: false,
      closeOnSelect: true,
      // disableWeekDays: [],
      // mondayFirst: true,
      // setLabel: 'Select a Date',
      // todayLabel: 'Today',
      // closeLabel: 'Close',
      // disabledDates: [],
      titleLabel: 'Select a Date',
      // monthsList: ['Jan', 'Feb', 'March', 'April', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
      // weeksList: ['S', 'S', 'M', 'T', 'W', 'T', 'F'],
      // dateFormat: 'MMMM D, YYYY',
      clearButton: false,
      showTodayButton: false,
      // momentLocale: 'pt-BR',
      // yearInAscending: true,
      // btnCloseSetInReverse: false,

      btnProperties: {
        expand: 'block', // 'block' | 'full'
        fill: '', // 'clear' | 'default' | 'outline' | 'solid'
        size: '', // 'default' | 'large' | 'small'
        // disabled: 'true', // boolean (default false)
        strong: '', // boolean (default false)
        color: '#ffffff'
        // 'primary', 'secondary', 'tertiary', 'success', 'warning', 'danger', 'light', 'medium', 'dark' , and give color in string
      }
    };
    this.timeSlotCaption = '';
    // (please assign time with proper format which is describe below)
    this.timePickerObj = {
      inputTime: '11:01 PM', // for 12 hour time in timePicker
      timeFormat: '', // default 'hh:mm A'
      setLabel: 'Set', // default 'Set'
      closeLabel: 'Close', // default 'Close'
      titleLabel: 'Select a Time', // default 'Time'
      clearButton: false, // default true
      btnCloseSetInReverse: true, // default false
      momentLocale: 'pt-BR', //  default 'en-US'

      btnProperties: {
        expand: '', // "block" | "full" (deafault 'block')
        fill: '', // "clear" | "default" | "outline" | "solid" 
        // (deafault 'solid')
        size: '', // "default" | "large" | "small" (deafault 'default')
        disabled: '', // boolean (default false)
        strong: '', // boolean (default false)
        color: '#ffffff'
        // "primary", "secondary", "tertiary", "success", 
        // "warning", "danger", "light", "medium", "dark" , 
        // and give color in string (default 'primary')
      }
    };
  }
}
